export default "__VITE_ASSET__B76S4FJ0__"